import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from '../../utils/posthogClient';
import { sources, findSourceByLandingURL } from '../../data/sources';

/**
 * PostHog tracker component that automatically captures pageview events
 * for React Router navigation changes
 */
export const PostHogTracker = () => {
    const location = useLocation();

    useEffect(() => {

        // If not production, disable tracking
        if (process.env.REACT_APP_NODE_ENV === 'Dev') return;

        const pathParts = location.pathname.split('/');
        const sourceSegment = pathParts.length > 1 ? pathParts[1].toLowerCase() : '';

        // Avoid capturing redirect pages for known sources that delete the path segment
        // (they redirect to / and the pageview fires there instead)
        const sourceForSegment = findSourceByLandingURL(sourceSegment);
        if (sourceSegment && sourceForSegment && sourceForSegment.deletePathSegment) return;

        const utm_source = new URLSearchParams(location.search).get('utm_source')?.toLowerCase() || undefined;

        // Capture a pageview event on route change
        posthog.capture('$pageview', {
            $current_url: window.location.href,
            $pathname: location.pathname,
            $search: location.search,
            $hash: location.hash,
            utm_source: utm_source
        });
        
    }, [location.pathname, location.search, location.hash]);

    // This component doesn't render anything
    return null;
};